import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../types";

interface GlobalErrorState {
  code: string | null;
}

const initialState: GlobalErrorState = {
  code: null,
};

const errorSlice = createSlice({
  name: "globalError",
  initialState,
  reducers: {
    setGlobalError: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
    },
    clearGlobalError: state => {
      state.code = null;
    },
  },
});

export const { setGlobalError, clearGlobalError } = errorSlice.actions;
export default errorSlice.reducer;

export const selectGlobalErrorCode = (state: RootState) =>
  state.globalError.code;
